import { OrganizationSettingsSpecificEvent } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrganizationSettingsSpecificEvent>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminOrgSettingSpecificEventReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminOrganizationSettingSpecificEvent.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminOrganizationSettingSpecificEvent.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminOrganizationSettingSpecificEvent.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminOrganizationSettingSpecificEvent.reset.type]: actionsHandlers.handleGetOneReset,
  [actions.updateAdminOrganizationSetting.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.updateAdminOrganizationSetting.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.updateAdminOrganizationSetting.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.updateAdminOrganizationSetting.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default adminOrgSettingSpecificEventReducer;
